export default __webpack_public_path__ + "static/media/bio.54f5658c.png";